<div class="ins-card-stack">
  @for (card of cards(); track card.addressId) {
    <tidy-card #cardEl [attr.data-address-id]="card.addressId" class="ins-property-card">
      <div class="ins-property-card__head">
        @if (!card.isUnassigned) {
          <tidy-tag
            [color]="card.color"
            [addressId]="card.addressId" />
        }
        <div class="ins-property-card__name">
          <tidy-text
            [header]="card.name"
            [translate]="false" />
          @if (card.subtitle) {
            <span class="ins-property-card__dot">·</span>
            <tidy-text
              [helper]="card.subtitle"
              [translate]="false" />
          }
        </div>
        <span class="ins-chip ins-chip--corner" [ngClass]="'tone-' + card.pill.tone" [title]="card.pill.detail || '' | translate">
          {{ card.pill.label }}
        </span>
      </div>

      @if (card.policies.length === 0) {
        <div class="ins-policy-empty">
          <tidy-text
            [helper]="'No policy on file for this property.'" />
        </div>
        <div class="ins-steadily-banner" (click)="onGetQuote(card)">
          <tidy-image
            [src]="'assets/svg/shield-checkmark-outline.svg'"
            class="body-size" />
          <span class="ins-steadily-banner__text">{{ card.estimateLabel }}</span>
          @if (card.pricingIsSample) {
            <span class="ins-sample-note" [title]="'Sample pricing — a live Steadily estimate is not loaded for this property yet.' | translate">
              {{ 'sample' | translate }}
            </span>
          }
          <span class="ins-steadily-banner__link">{{ 'View Quote' | translate }}</span>
        </div>
      }

      @for (policy of card.policies; track policy.insuranceId) {
        <tidy-card-button (action)="onEditPolicy(card, policy)" class="ins-policy-button">
          <div class="ins-policy">
            <div class="ins-policy__top">
              <tidy-text
                [body]="policy.title"
                [translate]="false"
                class="bold" />
              @for (chip of policy.chips; track chip.label) {
                <span class="ins-chip" [ngClass]="'tone-' + chip.tone" [title]="chip.detail || '' | translate">{{ chip.label }}</span>
              }
            </div>
            <div class="ins-policy__meta">{{ policy.metaLine }}</div>
            @if (policy.savingsLabel) {
              <div class="ins-steadily-banner" (click)="onViewQuote(card, policy, $event)">
                <tidy-image
                  [src]="'assets/svg/trending-down-outline.svg'"
                  class="body-size" />
                <span class="ins-steadily-banner__text">{{ policy.savingsLabel }}</span>
                @if (card.pricingIsSample) {
                  <span class="ins-sample-note" [title]="'Sample pricing — a live Steadily estimate is not loaded for this property yet.' | translate">
                    {{ 'sample' | translate }}
                  </span>
                }
                <span class="ins-steadily-banner__link">{{ 'View Quote' | translate }}</span>
              </div>
            }
          </div>
        </tidy-card-button>
      }
    </tidy-card>
  }
</div>
